/// <amd-module name="Wit/WorkItemForm/Links/GitHub/GitHubPullRequestSelection" />
import { IVssPageContext } from "VSS/Platform/Context";
import { FormItem } from "VSSUI/FormItem";
import { ExternalGitPullRequest, ExternalGitRepo } from "Wit/Clients/Internal/Contracts/ExternalEvents";
import * as Resources from "Wit/WorkItemForm/Resources";
import * as React from "react";
import { GitHubArtifactDropdownWithInfiniteScrolling, IconType } from "./GitHubArtifactDropdownWithInfiniteScrolling";

interface IGitHubPullRequestSelectionProps {
    pageContext: IVssPageContext;
    selectedRepository?: ExternalGitRepo;
    selectedPullRequest: ExternalGitPullRequest | undefined;
    setSelectedPullRequest: (pullRequest: ExternalGitPullRequest | undefined) => void;
    setShowSetUrlManually: (value: boolean) => void;
    cacheGitHubArtifactsFFEnabled?: boolean;
}

export const GitHubPullRequestSelection: React.FC<IGitHubPullRequestSelectionProps> = props => {
    return (
        <FormItem label={Resources.GithubPullRequestLabel}>
            <GitHubArtifactDropdownWithInfiniteScrolling<ExternalGitPullRequest>
                pageContext={props.pageContext}
                selectedArtifact={props.selectedPullRequest}
                setSelectedArtifact={props.setSelectedPullRequest}
                dropdownIconName="BranchPullRequest"
                dropdownId="id"
                dropdownText={["number", "title"]}
                dropdownIconColors={{
                    artifactAttribute: "state",
                    artifactAttributeColors: [
                        { artifactAttributeValue: "closed", iconType: IconType.ERROR, title: Resources.GithubPullRequestStateClosed },
                        { artifactAttributeValue: "merged", iconType: IconType.INFO, title: Resources.GithubPullRequestStateMerged },
                        { artifactAttributeValue: "open", iconType: IconType.SUCCESS, title: Resources.GithubPullRequestStateOpen }
                    ]
                }}
                infiniteScrollingDataProviderId="ms.vss-work-web.github-pull-requests-data-provider"
                cacheArtifacts={props.cacheGitHubArtifactsFFEnabled}
                setShowSetUrlManually={props.setShowSetUrlManually}
                resources={{
                    noResultsMessage: Resources.GithubPullRequestsEmptyMessage,
                    dropdownTextTemplate: Resources.GithubPullRequestsDropdownText,
                    loadingMessage: Resources.GithubPullRequestsLoadingMessage,
                    loadingFailedMessage: Resources.GithubPullRequestsLoadingFailedMessage,
                    entities: Resources.GithubPullRequests
                }}
                requireGitHubRepositoryContext
                gitHubRepositoryContext={props.selectedRepository}
            />
        </FormItem>
    );
};
